// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const version = {
  number: '2.0.0',
  date: 1773151091395
};
